import React, { useEffect, useState } from "react";
import { getFeedback, getReadFeedback, setFeedBack } from "../../API";
import FeedbackChild from "../../Components/Feedback";

const Feedback = () => {
  const [feeds, setFeedback] = useState([]);
  const [active, setActive] = useState(0);
  const [hiddens, setHidden] = useState([]);

  //   getting values
  const getHiddenFeeds = async () => {
    let feeds = await getReadFeedback();
    console.log(feeds);
    setHidden(feeds.data.object.content);
  };
  const getFeeds = async () => {
    let feeds = await getFeedback();
    console.log(feeds);
    setFeedback(feeds.data.object.content);
  };
  useEffect(() => {
    getFeeds();

    getHiddenFeeds();
  }, []);

  //   o'qilganligini belgilash
  const setRead = (id) => {
    setFeedBack(id);
  };

  return (
    <div className="">
      <div className="row justify-content-evenly">
        <button
          className={`btn col-5 ${
            active == 0
              ? "btn-outline-info text-color-info"
              : "btn-info text-white"
          }`}
          onClick={() => {
            getFeeds();
            setActive(0);
          }}
        >
          O'qilmaganlar
        </button>
        <button
          className={`btn col-5 ${
            active == 1
              ? "btn-outline-info text-color-info"
              : "btn-info text-white"
          }`}
          onClick={() => {
            getHiddenFeeds();
            setActive(1);
          }}
        >
          O'qilganlar
        </button>
      </div>
      {active == 0 ? (
        feeds.length !== 0 ? (
          feeds.map((v, i) => (
            <FeedbackChild
              data={v}
              key={i}
              read_callback={setRead}
              read={false}
            />
          ))
        ) : (
          <div className="p-2 m-2 w-100 bg-white shadow text-center rounded">
            Hozircha xabarlar yo'q
          </div>
        )
      ) : (
        ""
      )}
      {active == 1 ? (
        hiddens.length !== 0 ? (
          hiddens
            .reverse()
            .map((v, i) => (
              <FeedbackChild
                data={v}
                key={i}
                read_callback={(e) => console.log(e)}
                read={true}
              />
            ))
        ) : (
          <div className="p-2 m-2 w-100 bg-white shadow text-center rounded">
            {" "}
            O'qilganlar yo'q
          </div>
        )
      ) : (
        ""
      )}
    </div>
  );
};

export default Feedback;



// WEBPACK FOOTER //
// ./src/Pages/feedback/index.js